let requestAnimationFrame = (
  window.requestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.msRequestAnimationFrame ||
  function(callback) { setTimeout(callback, 0); }
);

export default function setImmediate(callback) {
  requestAnimationFrame(() => {
    callback();
  });
}

